import {combineReducers} from "@reduxjs/toolkit";

import responseHandling from "./responseHandling/responseHandling.reducers.js";
import waiver from "./waiver/waiver.reducers.js";
import onlineSales from "./onlineSales/onlineSales.reducers.js";
import onlineSalesProcess from "./onlineSalesProcess/onlineSalesProcess.reducers.js";


const reducers =  combineReducers({
  responseHandling,
  waiver,
  onlineSales,
  onlineSalesProcess
})


export {reducers as default}